import { FAQ_ITEMS } from "@/components/Seo";

/**
 * Homepage FAQ. Rendered with native <details>/<summary> so every answer is
 * present in the (pre-rendered) HTML and readable by search + AI answer engines
 * without running JS, while staying keyboard- and screen-reader-accessible.
 * The matching FAQPage JSON-LD is emitted from the page's <Seo> (see Index).
 * The first answer starts open so the section shows its content at a glance.
 */
const FaqSection = () => (
  <section id="faq" className="section-padding" aria-labelledby="faq-heading">
    <div className="max-w-7xl mx-auto grid gap-10 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-4">
        <p className="eyebrow mb-4">FAQ</p>
        <h2
          id="faq-heading"
          className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4"
        >
          Frequently Asked Questions
        </h2>
        <p className="text-lg leading-relaxed text-muted-foreground mb-6">
          Common questions about WCAG compliance, accessibility law in India, and
          what an audit involves.
        </p>
        <p className="text-base text-muted-foreground">
          Something else?{" "}
          <a
            href="#contact"
            className="font-semibold text-primary underline underline-offset-4 hover:text-primary/80 focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus-ring rounded-sm"
          >
            Ask us directly
          </a>
          .
        </p>
      </div>

      <div className="lg:col-span-8 divide-y divide-border border-y border-border">
        {FAQ_ITEMS.map((item, i) => (
          <details key={item.question} className="group py-1" open={i === 0}>
            <summary className="flex cursor-pointer items-center justify-between gap-6 py-4 text-left font-display text-lg font-semibold text-foreground focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus-ring rounded-sm list-none [&::-webkit-details-marker]:hidden">
              <span>{item.question}</span>
              <span
                aria-hidden="true"
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-input text-xl leading-none text-primary transition-transform group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <div className="pb-5 md:pr-14 text-base leading-relaxed text-muted-foreground">
              {item.answer}
            </div>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default FaqSection;
